var map = {
	"./Amex.svg": 1559,
	"./Apple.svg": 1560,
	"./Arrow-Coverage-Dark.svg": 1561,
	"./Arrow-Coverage-Light.svg": 1562,
	"./Arrow-Coverage.svg": 1563,
	"./Arrow-Element.svg": 1564,
	"./Arrow-Macro-Light.svg": 1565,
	"./Arrow-Macro.svg": 1566,
	"./Arrow-Micro-Dark.svg": 1567,
	"./Arrow-Micro.svg": 1568,
	"./Auth.svg": 1569,
	"./Close-Dark.svg": 1570,
	"./Close-Light.svg": 1571,
	"./Coverage-Dark.svg": 1572,
	"./Coverage-Light.svg": 1573,
	"./Credit-Card.svg": 1574,
	"./Data-Dark-16.svg": 1575,
	"./Data-Dark.svg": 1576,
	"./Data-Light-16.svg": 1577,
	"./Data-Light.svg": 1578,
	"./Down-Arrow.svg": 1579,
	"./Facebook-Original.svg": 1580,
	"./Footer-Amex.svg": 1581,
	"./Footer-Arrow-Close.svg": 1582,
	"./Footer-Arrow-Open.svg": 1583,
	"./Footer-Facebook.svg": 1584,
	"./Footer-Instagram.svg": 1585,
	"./Footer-Linkedin.svg": 1586,
	"./Footer-MasterCard.svg": 1587,
	"./Footer-Paypal.svg": 1588,
	"./Footer-Twitter.svg": 1589,
	"./Footer-VK.svg": 1590,
	"./Footer-Visa.svg": 1591,
	"./Footer-X.svg": 1592,
	"./GooglePlayStore.svg": 1593,
	"./ID.svg": 1594,
	"./Information.svg": 1595,
	"./Inline-American-Express.svg": 1596,
	"./Inline-MasterCard.svg": 1597,
	"./Inline-Unionpay.svg": 1598,
	"./Inline-Visa.svg": 1599,
	"./Input-Search-Dark.svg": 1600,
	"./Input-Search-Light.svg": 1601,
	"./Linkedin-Light.svg": 1602,
	"./Log-out-red.svg": 1603,
	"./Log-out.svg": 1604,
	"./Logo.svg": 1605,
	"./Manual-Install.svg": 1606,
	"./Mastercard.svg": 1607,
	"./PayPal.svg": 1608,
	"./Plus.svg": 1609,
	"./Price-Dark.svg": 1610,
	"./Price-Light.svg": 1611,
	"./QR.svg": 1612,
	"./Readonly-Input-Lock.svg": 1613,
	"./Saved-Amex.svg": 1614,
	"./Saved-MasterCard.svg": 1615,
	"./Saved-Visa.svg": 1616,
	"./Search.svg": 1617,
	"./Secure-Auth.svg": 1618,
	"./Secure-W.svg": 1619,
	"./Secure.svg": 1620,
	"./Share.svg": 1621,
	"./Star_color.svg": 1622,
	"./Store-Active-Dark.svg": 1623,
	"./Store-Active-Light.svg": 1624,
	"./Store-B.svg": 1625,
	"./Store-Inactive.svg": 1626,
	"./Store-W.svg": 1627,
	"./Store.svg": 1628,
	"./Success.svg": 1629,
	"./Trash.svg": 1630,
	"./Twitter-Original.svg": 1631,
	"./User-Active-Dark.svg": 1632,
	"./User-Active-Light.svg": 1633,
	"./User-Inactive.svg": 1634,
	"./Validity-Dark.svg": 1635,
	"./Validity-Light.svg": 1636,
	"./Visa.svg": 1637,
	"./What-is-This.svg": 1638,
	"./copy.svg": 1639,
	"./eSIM-Active-Dark.svg": 1640,
	"./eSIM-Active-Light.svg": 1641,
	"./eSIM-Dark.svg": 1642,
	"./eSIM-Inactive.svg": 1643,
	"./eSIM-Light.svg": 1644,
	"./email.svg": 1645,
	"./facebook.svg": 1646,
	"./ic_add-card.svg": 1647,
	"./ic_airmoney_macro.svg": 1648,
	"./ic_airmoney_micro.svg": 1649,
	"./ic_airmoney_pay.svg": 1650,
	"./ic_airmoney_payment-method.svg": 1651,
	"./ic_alipay_payment-method-dark.svg": 1652,
	"./ic_alipay_payment-method-light.svg": 1653,
	"./ic_amex.svg": 1654,
	"./ic_apple-dark.svg": 1655,
	"./ic_apple-light.svg": 1656,
	"./ic_apple-pay_payment-method.svg": 1657,
	"./ic_arrow_slider_active_Light.svg": 1658,
	"./ic_arrow_slider_inactive_Light.svg": 1659,
	"./ic_back_header-dark.svg": 1660,
	"./ic_back_header-light.svg": 1661,
	"./ic_banner_refeere.svg": 1662,
	"./ic_banner_referrer.svg": 1663,
	"./ic_bill_to_org_payment-method-light.svg": 1664,
	"./ic_calls.svg": 1665,
	"./ic_checkbox_active.svg": 1666,
	"./ic_checkbox_inactive.svg": 1667,
	"./ic_chevron-right.svg": 1668,
	"./ic_chip.svg": 1669,
	"./ic_clear.svg": 1670,
	"./ic_close_white.svg": 1671,
	"./ic_copy.svg": 1672,
	"./ic_coverage.svg": 1673,
	"./ic_credit-card_payment-method-dark.svg": 1674,
	"./ic_credit-card_payment-method-light.svg": 1675,
	"./ic_data.svg": 1676,
	"./ic_delete_white.svg": 1677,
	"./ic_discount-code.svg": 1678,
	"./ic_edit_white.svg": 1679,
	"./ic_esim.svg": 1680,
	"./ic_expire.svg": 1681,
	"./ic_fup.svg": 1682,
	"./ic_google-pay.svg": 1683,
	"./ic_google-pay_payment-method.svg": 1684,
	"./ic_google.svg": 1685,
	"./ic_help_center.svg": 1686,
	"./ic_install.svg": 1687,
	"./ic_jcb.svg": 1688,
	"./ic_logout.svg": 1689,
	"./ic_long-back-arrow.svg": 913,
	"./ic_manual_install.svg": 1690,
	"./ic_mastercard.svg": 1691,
	"./ic_notification.svg": 1692,
	"./ic_package.svg": 1693,
	"./ic_paypal_payment-method-dark.svg": 1694,
	"./ic_paypal_payment-method-light.svg": 1695,
	"./ic_play.svg": 1696,
	"./ic_price.svg": 1697,
	"./ic_price_v2.svg": 1698,
	"./ic_qrcode_install.svg": 1699,
	"./ic_routing.svg": 1700,
	"./ic_screenshot.svg": 1701,
	"./ic_sms.svg": 1702,
	"./ic_statistic.svg": 1703,
	"./ic_store_header.svg": 1704,
	"./ic_stripe.svg": 885,
	"./ic_subscription.svg": 1705,
	"./ic_success.svg": 1706,
	"./ic_success_banner.svg": 1707,
	"./ic_success_order-completed.svg": 1708,
	"./ic_telegram.svg": 1709,
	"./ic_tips.svg": 1710,
	"./ic_unionpay.svg": 1711,
	"./ic_validity.svg": 1712,
	"./ic_visa.svg": 1713,
	"./ic_visa_payment-method.svg": 1714,
	"./ic_visa_saved-card.svg": 1715,
	"./ic_whatsapp.svg": 1716,
	"./icon-ekyc-detail-card-info.svg": 1717,
	"./icon-ekyc-detail-driver-license.svg": 1718,
	"./icon-ekyc-detail-faq-arrow.svg": 1719,
	"./icon-ekyc-detail-finger-print.svg": 1720,
	"./icon-ekyc-detail-identity-card.svg": 1721,
	"./icon-ekyc-detail-jumio.svg": 1722,
	"./icon-ekyc-detail-passport.svg": 1723,
	"./icon-esim-detail-copy-dark.svg": 1724,
	"./icon-esim-detail-copy-light.svg": 1725,
	"./icon-esim-detail-coverage-arrow-dark.svg": 1726,
	"./icon-esim-detail-coverage-arrow-light.svg": 1727,
	"./icon-esim-detail-error-text-field-dark.svg": 1728,
	"./icon-esim-detail-error-text-field-light.svg": 1729,
	"./icon-header-airmoney.svg": 1730,
	"./icon-header-arrow-close.svg": 1731,
	"./icon-header-language.svg": 1732,
	"./icon-header-myesim.svg": 1733,
	"./icon-header-profile.svg": 1734,
	"./icon-header-store.svg": 1735,
	"./icon-hero-rating-appstore.svg": 1736,
	"./icon-hero-rating-googleplay.svg": 1737,
	"./icon-homepage-country-arrow-close.svg": 1738,
	"./icon-homepage-country-arrow-open.svg": 1739,
	"./icon-homepage-country-data-dark-16.svg": 1740,
	"./icon-homepage-country-data-dark-22.svg": 1741,
	"./icon-homepage-country-data-light-16.svg": 1742,
	"./icon-homepage-country-data-light-22.svg": 1743,
	"./icon-info-general-dark.svg": 1744,
	"./icon-info-general-light.svg": 1745,
	"./icon-mob-website-expansion-item-arrow.svg": 1746,
	"./icon-myesims-checklist.svg": 1747,
	"./icon-myesims-nosign.svg": 1748,
	"./icon-myesims-trash-slash.svg": 1749,
	"./icon-myesims-wifi-exclamationmark.svg": 1750,
	"./icon-orders-billed-to.svg": 1751,
	"./icon-package-3g-light.svg": 886,
	"./icon-package-4g-light.svg": 887,
	"./icon-package-5g-light.svg": 888,
	"./icon-package-activation-policy-light.svg": 889,
	"./icon-package-arrow-general-light.svg": 890,
	"./icon-package-calling-credit-light.svg": 891,
	"./icon-package-coverage-dark.svg": 1752,
	"./icon-package-coverage-light.svg": 892,
	"./icon-package-ekyc-micro-light.svg": 893,
	"./icon-package-ekyc-restriction-light.svg": 894,
	"./icon-package-ekyc-validation-light.svg": 895,
	"./icon-package-fup-dark.svg": 1753,
	"./icon-package-fup-light.svg": 896,
	"./icon-package-info-general-light.svg": 897,
	"./icon-package-lte-light.svg": 898,
	"./icon-package-network-light.svg": 899,
	"./icon-package-plan-type-light.svg": 900,
	"./icon-package-price-dark.svg": 1754,
	"./icon-package-price-light.svg": 901,
	"./icon-package-supported-arrow-dark.svg": 1755,
	"./icon-package-supported-arrow-light.svg": 902,
	"./icon-package-topup-option-light.svg": 903,
	"./icon-package-validity-dark.svg": 1756,
	"./icon-package-validity-light.svg": 904,
	"./icon-partner-with-us-breadcrumb-arrow.svg": 1757,
	"./icon-password-hidden-error.svg": 1758,
	"./icon-password-hidden.svg": 1759,
	"./icon-password-visible-error.svg": 1760,
	"./icon-password-visible.svg": 1761,
	"./icon-search-clear.svg": 1762,
	"./icon-search.svg": 1763,
	"./icon-unlimited-dark.svg": 1764,
	"./icon-unlimited-light.svg": 1765,
	"./icon-website-expansion-content-box-bg-sm.svg": 1766,
	"./icon-website-expansion-content-box-bg.svg": 1767,
	"./mail.svg": 1768,
	"./order-async/my-esims/top-up-is-delayed.svg": 1769,
	"./order-async/my-esims/top-up-is-failed.svg": 1770,
	"./order-async/my-esims/top-up-is-on-the-way.svg": 1771,
	"./settings_button.svg": 1772,
	"./tabs-Airmoney.svg": 1773,
	"./tabs-Credit-Card.svg": 1774,
	"./tabs-PayPal.svg": 1775,
	"./telegram.svg": 1776,
	"./tick-light.svg": 1777,
	"./twitter.svg": 1778,
	"./whatsapp.svg": 1779
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1558;